import type { SearchTileDensity } from 'components/SearchKit/SearchTiles/searchTileDensity'
import { getSearchTileDensityClassName } from 'components/SearchKit/SearchTiles/searchTileDensity'
import NumberRating from 'components/Common/NumberRating'
import clsx from 'clsx'
import { rem } from 'polished'
import type { PropsWithChildren, ReactElement } from 'react'
import styled from 'styled-components'
import { _searchTileContainerQueryUp } from './_MetaSearchTileBase'

const Container = styled.div`
  grid-area: content-secondary;
  display: flex;
  flex-direction: column;
  gap: ${rem(12)};
  justify-content: space-between;
  width: 100%;

  align-items: flex-end;

  ${_searchTileContainerQueryUp.tablet} {
    align-self: stretch;
  }
`

const PricingContainer = styled.div<{ $anchorToBottom: boolean }>`
  display: flex;
  flex-direction: row;
  gap: ${rem(16)};
  ${props => props.$anchorToBottom && 'margin-top: auto;'}
  justify-content: flex-start;
  width: 100%;

  & > * {
    flex: 1;
  }

  &.density-compact {
    flex-direction: column;
    gap: ${rem(12)};

    & > * {
      flex: 0 1 auto;
    }
  }

  ${_searchTileContainerQueryUp.tablet} {
    justify-content: flex-end;

    &.density-compact {
      justify-content: flex-start;
    }
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    justify-content: flex-start;
  }

  ${_searchTileContainerQueryUp.desktopLarge} {
    justify-content: flex-end;

    &.density-compact {
      justify-content: flex-start;
    }
  }
`

const RatingContainer = styled.div`
  display: none;

  ${_searchTileContainerQueryUp.tablet} {
    display: block;
  }

  ${_searchTileContainerQueryUp.desktopSmall} {
    display: none;
  }

  ${_searchTileContainerQueryUp.desktop} {
    display: block;
  }
`

interface Props extends PropsWithChildren {
  anchorPricingToBottom?: boolean
  callToAction?: ReactElement
  rating?: App.OfferRating
  /**
   * @default default
   */
  density?: SearchTileDensity
}

function _MetaSearchTileContentSecondary({
  children,
  anchorPricingToBottom = false,
  rating,
  density = 'default',
}: Props) {
  const densityClassName = getSearchTileDensityClassName(density)

  return <Container className={clsx(_MetaSearchTileContentSecondary.name, densityClassName)}>
    {rating && <RatingContainer>
      <NumberRating
        rating={rating.score}
        total={rating.reviewsTotal}
        variant="small"
        numberPosition="end"
      />
    </RatingContainer>}
    <PricingContainer $anchorToBottom={anchorPricingToBottom} className={densityClassName}>{children}</PricingContainer>
  </Container>
}

export default _MetaSearchTileContentSecondary
